import React from "react";
import { useNavigate } from "react-router-dom";
import { StyledButton } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";

import {
    setMultiShopSwitch,
    setNumberClick,
    setOneShopSwitch,
} from "@components/VerticalLayout/store";

import { getData } from "../../helpers/general";

import "./index.css";
import { setAllAuthorized, setSelectedAccount } from "../../redux/globalSlice";
import { useDispatch, useSelector } from "react-redux";

export function CustomIconsComponent({ e }: any) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const uuidUser = localStorage.getItem("uuidUser");
    function setShop(
        franchiseId: string,
        shopId: string,
        pays: string,
        shopName: string
    ) {
        setOneShopSwitch(franchiseId, shopId, pays, shopName);

        navigate("/setting/customer-account");
    }
    function setFranchise(franchiseId: string, shopName: string) {
        setMultiShopSwitch(franchiseId, shopName);

        navigate("/setting/customer-account");
    }

    async function handleOnClickEvent() {
        setNumberClick(0);

        let franchiseId =
            e.selectedRow.Kind === "Franchise"
                ? e.selectedRow.uid
                : e.selectedRow.uuidFranchise;
        let shopId =
            e.selectedRow.Kind === "Franchise" ? "0" : e.selectedRow.uid;

        await getData(franchiseId, uuidUser as string, shopId);

        if (
            ["boutique", "Boutique"].includes(e.selectedRow["Account type"]) ||
            ["boutique", "Boutique"].includes(e.selectedRow.Nature) ||
            ["boutique", "Boutique"].includes(e.selectedRow.Kind)
        ) {
            dispatch(
                setSelectedAccount(
                    e.selectedRow[t("Commercial name")] ??
                        e.selectedRow["Nom commercial"]
                )
            );

            setShop(
                e.selectedRow.Kind === "Franchise"
                    ? e.selectedRow.uid
                    : e.selectedRow.uuidFranchise,
                e.selectedRow.uid,
                e.selectedRow[t("Country")],
                e.selectedRow[t("Commercial name")] ??
                    e.selectedRow["Nom commercial"]
                // e.selectedRow["Société"]LOCAL,
            );
        } else {
            if (
                e.selectedRow.childs_profilelink.filter(
                    (el: any) => el.etat === "Activé"
                ).length === e.selectedRow.subRows.length
            ) {
                dispatch(setAllAuthorized(true));
            } else {
                dispatch(setAllAuthorized(false));
            }
            dispatch(
                setSelectedAccount(
                    e.selectedRow[t("Commercial name")] ??
                        e.selectedRow["Nom commercial"]
                )
            );
            setFranchise(
                e.selectedRow.uid,
                e.selectedRow[t("Commercial name")] ??
                    e.selectedRow["Nom commercial"]
            );
        }
    }
    return (
        <React.Fragment>
            {["Franchise", "franchise", "Boutique", "boutique"].includes(
                e.selectedRow.Nature
            ) ||
            ["Franchise", "franchise", "Boutique", "boutique"].includes(
                e.selectedRow["Account type"]
            ) ||
            ["Franchise", "franchise", "Boutique", "boutique"].includes(
                e.selectedRow.Kind
            ) ? (
                <StyledButton
                    outline
                    rounded
                    variant={mainColor}
                    onClick={handleOnClickEvent}
                >
                    {t("To access")}
                </StyledButton>
            ) : (
                <div></div>
            )}
        </React.Fragment>
    );
}
